import { ReactElement, useEffect } from 'react'

import TechnicalError from 'pages/AccountsDashboard/TechnicalError'
import styled from 'styled-components'
import Inset from 'syf-component-library/ui/spacing/Inset'
import { isDeepLinkSession, setDeepLinkStatus } from 'helpers/deepLinkAnalytics'

const ErrorWrapper = styled(Inset)`
  display: flex;
  justify-content: center;
`

const ErrorPage = (): ReactElement => {
  useEffect(() => {
    if (isDeepLinkSession()) {
      setDeepLinkStatus('failure')
    }
  }, [])

  return (
    <ErrorWrapper top="xlarge">
      <TechnicalError errorType="fullPageError" />
    </ErrorWrapper>
  )
}

export default ErrorPage
